import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[atlPreventDoubleSpace]',
  standalone: true,
})
export class PreventDoubleSpaceDirective {
  @Input() maxLength = 30;
  @Input() currentValue!: string | undefined;
  @Input() hasDoubleSpace = true;
  private readonly doubleSpace = '  ';
  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (!this.hasDoubleSpace) return;
    if (this.el.nativeElement.value?.length >= this.maxLength) {
      event.preventDefault();
      return;
    }
    if (event.key !== ' ') {
      return;
    }

    const selectionStart: number = this.el.nativeElement.selectionStart;
    if (selectionStart === 0 && event.key === ' ') {
      event.preventDefault();
      return;
    }

    const current: string = this.el.nativeElement.value;
    if (current.charAt(selectionStart - 1).concat(event.key) === this.doubleSpace) {
      event.preventDefault();
    }
  }

  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent): void {
    if (!this.hasDoubleSpace) return;
    const dataToPaste = event?.clipboardData?.getData('text');
    if (!dataToPaste) {
      return;
    }

    if (dataToPaste && dataToPaste.length) {
      const totalSymbols = this.currentValue?.length
        ? this.currentValue.length + dataToPaste.length
        : dataToPaste.length;
      if (totalSymbols > this.maxLength) {
        event.preventDefault();
        this.el.nativeElement.value = this.replaceWithSingleSpace(dataToPaste).substring(0, this.maxLength);
      }
    }

    if (dataToPaste.includes(this.doubleSpace)) {
      event.preventDefault();
      this.el.nativeElement.value = this.replaceWithSingleSpace(dataToPaste);
    }

    if (dataToPaste.charAt(0) === ' ') {
      this.el.nativeElement.value = dataToPaste?.replace(' ', '');
    }
  }

  private replaceWithSingleSpace(value: string): string {
    return value.replace(/\s\s+/g, ' ');
  }
}
